import { AxiosInstance } from "../../axios/axiosInstance";
import { apiRoutes } from "../../utils/ApiRoutes";
import { ISetupAgency, ITestSMTP } from "../actions/AgencyAction";
import { IPagination } from "./AdminApis/AdminDataApi";

export const SetupAgencyApi = async (payload: ISetupAgency) => {
    const response = await AxiosInstance.post(apiRoutes?.agencySetup, payload);
    return response
}
export const getAgencyApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.agency);
    return response
}
export const validateSMTPApi = async (payload: ITestSMTP) => {
    const response = await AxiosInstance.post(apiRoutes?.validateSMTP, payload);
    return response
}
export const testSMTPApi = async (email: string) => {
    const response = await AxiosInstance.post(apiRoutes?.testEmail, { email });
    return response
}

export const VerifyDomainApi = async (domain: string) => {
    const response = await AxiosInstance.post(apiRoutes?.agencyVerifyDomain, { domain });
    return response
}

export const UpdateAgencyApi = async (payload: Partial<ISetupAgency>) => {
    const response = await AxiosInstance.put(apiRoutes?.agencyUpdate, payload);
    return response
}

export const getWorkspaceWidgetDataApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.workspaceWidget)
    return response
}

export const createWorkspaceWidgetDataApi = async (payload: any) => {
    const response = await AxiosInstance.post(apiRoutes?.workspaceWidget, payload)
    return response
}

export const updateWorkspaceWidgetDataApi = async (payload: any) => {
    const response = await AxiosInstance.put(apiRoutes?.workspaceWidget, payload)
    return response
}

export const workspaceWidgetReportDataApi = async (payload: IPagination) => {
    const response = await AxiosInstance.post(apiRoutes?.workspaceReport, payload)
    return response
}

export const workspaceWidgetRetryScanApi = async (scan_id: string) => {
    const response = await AxiosInstance.post(apiRoutes?.workspaceWidgetRetryScan, { scan_id })
    return response
}

export const workspaceWidgetReportExportApi = async () => {
    const response = await AxiosInstance.post(apiRoutes?.workspaceWidgetReportExport)
    return response
}

// Workspace based white label apis
export const workspaceDetailsApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.workspaceDetails);
    return response
}

export const workspaceUpdateApi = async (payload: Partial<ISetupAgency>) => {
    const response = await AxiosInstance.put(apiRoutes?.workspaceUpdate, payload);
    return response
}

export const workspaceVerifyDomainApi = async (domain: string) => {
    const response = await AxiosInstance.post(apiRoutes?.workspaceVerifyDomain, { domain });
    return response
}

export const workspaceValidateSMTPApi = async (payload: ITestSMTP) => {
    const response = await AxiosInstance.post(apiRoutes?.workspaceValidateSMTP, payload);
    return response
}

export const workspaceTestEmailApi = async (email: string) => {
    const response = await AxiosInstance.post(apiRoutes?.workspaceTestEmail, { email });
    return response
}